import IntlService from 'ember-intl/services/intl';
import { getOrElse } from 'volta/utils/object-utils';

import { inject as service } from '@ember/service';
import Component from '@glimmer/component';

interface IArgs {
  percent?: boolean;
  step?: number;
  value?: number;
  min?: number;
  max?: number;
}

export default class RangeInput extends Component<IArgs> {
  // Services
  // ~~~~~

  @service intl!: IntlService;

  // Computed Properties
  // ~~~~~

  // Only percent and number for now
  get percent() {
    return getOrElse(this.args.percent, true);
  }
  get step() {
    return this.args.step ?? 0.01;
  }
  get value() {
    return this.args.value ?? 0;
  }

  get min() {
    return this.args.min ?? 0;
  }

  get max() {
    return this.args.max ?? 1;
  }

  get formattedMin() {
    const { min = 0, percent } = this;
    return this.intl.formatNumber(min, percent ? { style: 'percent' } : undefined);
  }

  get formattedMax() {
    const { max = 1, percent } = this;
    return this.intl.formatNumber(max, percent ? { style: 'percent' } : undefined);
  }
}
